import tw, { styled } from 'twin.macro';
import Link from '@/components/Link/Link';

export const StyledContainer = styled.section`
  ${tw`container`}
  ${tw`container-stack-context`}
  ${tw`rounded-[12px]`}
`;

export const StyledSection = styled.div`
  ${tw`bg-neutrals-n1`}
  ${tw`grid lg:grid-cols-12`}
  ${tw`rounded-[12px]`}
`;

export const StyledEyebrow = styled.span`
  ${tw`font-inter font-semi-bold`}
  ${tw`text-tag-m`}
  ${tw`text-primary-p1`}
  ${tw`uppercase`}
  ${tw`block`}
  ${tw`mb-2`}
`;

export const StyledHeadline = styled.h3`
  ${tw`block`}
  ${tw`font-poppins font-semi-bold`}
  ${tw`text-mobile-heading-m lg:text-heading-m text-secondary-s1`}
  ${tw`mb-2 lg:mb-3`}
`;

export const StyledBody = styled.div`
  ${tw`font-inter font-medium lg:font-regular`}
  ${tw`text-body-s lg:text-body-l text-primary-p1`}
  ${tw`block`}
`;

export const StyledLink = styled(Link)`
  ${tw`font-inter font-semi-bold`}
  ${tw`text-text-cta`}
  ${tw`text-secondary-s1`}
  ${tw`mt-3 lg:mt-5`}
  ${tw`w-fit`}
`;

export const StyledContent = styled.div<{
  variant: Queries.kontent_item_n5050_card_block_elements_variant_enum;
}>`
  ${tw`relative`}
  ${tw`flex flex-col justify-center`}
  ${tw`px-2 py-5 lg:px-10 lg:py-[120px]`}
  ${tw`lg:col-span-6`}
`;

export const StyledImage = styled.div<{
  variant: Queries.kontent_item_n5050_card_block_elements_variant_enum;
}>`
  ${tw`bg-neutrals-n6`}
  ${tw`order-first lg:order-none`}
  ${({ variant }) => (variant === 'left' ? tw`lg:order-last` : tw`lg:order-first`)}
  ${tw`lg:col-span-6`}
  > div[data-gatsby-image-wrapper] {
    height: 100%;
  }
  &,
  img {
    ${tw`rounded-t-lg`}
    ${({ variant }) =>
      variant === 'left'
        ? tw`lg:rounded-r-xl lg:rounded-tl-none`
        : tw`lg:rounded-l-xl lg:rounded-tr-none`}
  }
`;
